   <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit your design name</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-11">
                    <mdb-form-control>
                        <input mdbInput
                        type="text" 
                        [(ngModel)]="designName"
                        id="autocomplete" 
                        class="form-control"
                        placeholder="Name your design..." 
                        (keyup.enter)="close()"/>
                    </mdb-form-control>
                </div>
                <div class="col-1 p-0">
                    <button type="button" class="btn btn-primary btn-floating" mdbTooltip="Edit name" mdbRipple
                        style="background-color: #032b49;" (click)="close()">
                        <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
